import { useEffect, useRef } from 'react'
import styles from './Downloads.module.scss'
import useHubSpotGenerate from 'hooks/useHubSpotGenerate'
import LeftContents from './LeftContents'
import { LeftContentDataType } from './types/types'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'

gsap.registerPlugin(ScrollTrigger)

const leftContentData: LeftContentDataType = {
  titleVol: <>失敗しないAI時代のモダナイゼーション戦略</>,
  alt: '失敗しないAI時代のモダナイゼーション戦略',
  readText: (
    <>DXやAI活用が進まない本質的な理由とは？計画から予算策定等、モダナイゼーションの最新動向をまとめたガイドライン</>
  ),
  imgLarge: '/images/img/download/modernization/thumbnail_modernization.webp',
  imgCapture: '/images/img/download/modernization/capture_modernization.webp',
  firstContentTitle: 'このような方におすすめ',
  firstHalf: (
    <>
      老朽化したシステムからの脱却を検討されている経営層や事業責任者、またクラウドやAIを活用したモダナイゼーションに関心を持つDX推進担当者や情報システム部門の方におすすめです。システム刷新によって事業成長を加速させたいとお考えの皆様にぜひご覧いただきたい内容となっています。
    </>
  ),
  secondContentTitle: 'この資料でわかること',
  secondHalf1: 'AIを「使える状態」にするための4つの必須要素',
  secondHalf2: '自社の現在地を特定する「タイプ別チェックシート」',
  secondHalf3: 'クラウドリフトからAI駆動開発まで、業務を止めずに進める7STEPロードマップ',
  secondHalf4: '開発工数80%削減、コスト40-60%カットの成果事例',
}

const DownloadModernization: React.FC = () => {
  const title_category = useRef<HTMLSpanElement>(null)
  const title_page = useRef<HTMLSpanElement>(null)
  useHubSpotGenerate('na1', '9395227', 'b3c08178-4840-41ae-9dc7-61d9a6e276e5', '#hbspt')
  useEffect(() => {
    gsap.set([title_category.current, title_page.current, `.${styles.read_text}`, `.${styles.section}`], {
      opacity: 0,
      y: 50,
    })

    const timeline = gsap.timeline({
      defaults: {
        opacity: 0,
        y: 50,
        duration: 1,
        ease: Power4.easeOut,
      },
    })

    const commonTo = { opacity: 1, y: 0 }

    timeline
      .to(title_category.current, commonTo, 0.2)
      .to(title_page.current, commonTo, 0.5)
      .to(`.${styles.read_text}`, commonTo, 0.8)
      .to(`.${styles.section}`, commonTo, 1.1)
  }, [])

  return (
    <article className={`${styles.main} downloadArea`}>
      <section className={styles.contents}>
        <h1 className={styles.ttl}>
          <span ref={title_category}>Download</span>
          <span ref={title_page}>{leftContentData.titleVol}</span>
        </h1>
        <p className={styles.read_text}>{leftContentData.readText}</p>
        <section className={styles.section}>
          <LeftContents leftContentData={leftContentData} isSecondContent={true} />
          <div className={styles.content}>
            <div className={styles.title_group}>
              <p className={styles.whitepaper}>
                ご入力いただいたメールアドレス宛に、資料ダウンロード用URLを送付いたします。
              </p>
              <p className={styles.notice}>※ 全ての項目をご入力ください。</p>
            </div>
            <div id="hbspt"></div>
          </div>
        </section>
      </section>
      <MailmagazineLink />
    </article>
  )
}

export default DownloadModernization
